import axios from 'axios';
import appConfig from '../../config/config';

import { generateKey, isMobileApp, navigateTo, showServiceError, showNotification, removeFromSessionStorage, getFromSessionStorage, enablePlatformLogin } from '../utils/app.utils';
import {
  MODULE_ID,
  AUTHORIZATION_HEADER,
  PNQ_AUTHORIZATION_HEADER,
  NOTIFICATION_TIMEOUT,
  INSTALLATION_PAGE_CUSTOMER_DETAIL,
  CUSTOMER_DETAIL,
  FEASIBILITY_DATA,
  DEDICATED_FEASIBILITY_DATA,
  FEASIBILITY_RESPONSE,
  AUTHORIZED_SIGNATORY,
  DEDICATED_FEASIBILITY_RESPONSE,
  DEDICATED_CUSTOMER_DETAIL,
  DEDICATED_INSTALLATION_PAGE_CUSTOMER_DETAIL,
  SUMMARY_AUTHORIZATION_HEADER,
  SELECTED_PARTY_ACCOUNT,
  SELECTED_PARTY_DATA,
  UNAUTH_ACTIVE_STEP
} from '../../home/common/constants/constants';
import { DEDICATED_COMMON_PARAMS, PRODUCT_TYPE, isAOIOrder } from '../constants/app.constants';
import { LEAD, ORDER } from 'tokenGeneration/constant';
import { logToSentry } from 'common/utils/sentry.utils';
const accessToken = localStorage.getItem('accessToken');
export const requestInterceptor = (request) => {
  if (isMobileApp() && !request.ignoreMobileApp) {
    let reqPayload = '';
    if (request.method !== 'GET' && request.data) {
      reqPayload = JSON.stringify(request.data);
    }
    // parse the api url without protocol in each case (http://abc.in/akak, https://abc.in/akak, //abc.in/akak)
    let apiRelativeUrl = window.location.protocol + '//' + request.url.substr(request.url.split('/', 2).join(4).length + 1);
    if (request.params && Object.keys(request.params).length) {
      apiRelativeUrl += '?';

      let sortedKeys = Object.keys(request.params).sort();
      for (let index = 0; index < sortedKeys.length; index++) {
        let key = sortedKeys[index];
        if (request.params[key] !== undefined && request.params[key] !== null) {
          apiRelativeUrl += key + '=' + request.params[key] + '&';
        }
      }
      apiRelativeUrl = apiRelativeUrl.substring(0, apiRelativeUrl.length - 1);
    }

    //GET app Headers
    let appHeaders = window.MyAirtelAppReact.getHeaders(request.method, apiRelativeUrl, reqPayload);

    //Parse App Headers
    appHeaders = String(appHeaders).replace(/\n/g, '');
    //  alert("header are : " + appHeaders + " and url is : " + apiRelativeUrl)
    appHeaders = JSON.parse(appHeaders);

    //to pass all the headers to server
    for (let key in appHeaders) {
      request.headers[key] = String(appHeaders[key]).replace(/\n/g, '');
    }

    request.headers['requestSrc'] = 'myAirtelApp';
  } else {
    let key = generateKey();
  }
  // if (request && !request.skipServiceType) {
  //   request.headers["serviceType"] = "DSL";
  // }
  if (request && !request.skipServiceType && request.config.dedicatedJourney) {
    request.headers['serviceType'] = DEDICATED_COMMON_PARAMS.serviceType ? DEDICATED_COMMON_PARAMS.serviceType : PRODUCT_TYPE.DEDICATED_INTERNET; // To be change
    //request.headers["app-id"] = "SELFCARE";
    //request.headers["iv-user"] = "test@gmail.com";
  }
  let authorization = getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
  let pnqToken = getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER);
  if (request && request.config && request.config.pnqToken) {
    request.headers['Authorization'] = request.config.pnqToken;
    if (appConfig.env !== 'DEV') {
      request.headers['app-id'] = 'SELFCARE';
    }
  }
  if (request && request.config && request.config.aehToken) {
    request.headers['Authorization'] = enablePlatformLogin() ? `Bearer ${request.config.aehToken}` : `Bearer ${request.config.aehToken}`;
    if (appConfig.env !== 'DEV') {
      request.headers['app-id'] = 'SELFCARE';
    }
  } else if (authorization && request && !request.skipServiceType) {
    request.headers['Authorization'] = authorization;
  } else {
    // window.location.href = appConfig.homePageUrl;
  }
  if (enablePlatformLogin()) {
    request.headers['Authentication'] = `Bearer ${accessToken}`;
  }
  return request;
};

export function repsonseErrorInterceptor(error, isError = true) {
  // if (isAOIOrder()) {
  //   return;
  // }
  const environment = appConfig?.env;
  const errorMessage = `Error on ${environment} in Request ${error?.config?.url}`;
  logToSentry(errorMessage, error, true);

  if (error.response && error.response.status === 401) {
    if (error.response.config && error.response.config.config && error.response.config.config.aehToken) {
      localStorage.removeItem('accessToken');
      removeFromSessionStorage(MODULE_ID, AUTHORIZED_SIGNATORY);
      removeFromSessionStorage(MODULE_ID, SELECTED_PARTY_ACCOUNT);
      removeFromSessionStorage(MODULE_ID, SELECTED_PARTY_DATA);
    } else {
      removeFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
      removeFromSessionStorage(MODULE_ID, CUSTOMER_DETAIL);
      removeFromSessionStorage(MODULE_ID, INSTALLATION_PAGE_CUSTOMER_DETAIL);
      removeFromSessionStorage(MODULE_ID, FEASIBILITY_DATA);
      removeFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE);
      removeFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_DATA);
      removeFromSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE);
      removeFromSessionStorage(MODULE_ID, DEDICATED_CUSTOMER_DETAIL);
      removeFromSessionStorage(MODULE_ID, DEDICATED_INSTALLATION_PAGE_CUSTOMER_DETAIL);
      removeFromSessionStorage(MODULE_ID, AUTHORIZED_SIGNATORY);
      removeFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER);
      removeFromSessionStorage(MODULE_ID, SELECTED_PARTY_ACCOUNT);
      removeFromSessionStorage(MODULE_ID, SELECTED_PARTY_DATA);
      removeFromSessionStorage(MODULE_ID, UNAUTH_ACTIVE_STEP);
      removeFromSessionStorage(MODULE_ID, LEAD);
      removeFromSessionStorage(MODULE_ID, ORDER);
    }
    showErrorModal(error, true);
  } else if (error?.response?.status === 500) {
    showErrorModal(error);
  } else {
    if (error && error.response && error.response.config && error.response.config.config && error.response.config.config.aehToken) {
    } else {
      showErrorModal(error);
    }
  }
  return isError ? Promise.reject(error) : error;
}

export function showErrorModal(error, redirect) {
  console.log('Interceptor Error');
  let errorMessage = '';
  if (error && error.response && error.response.data && error.response.data.errorMsg) {
    errorMessage = error.response.data.errorMsg;
  }
  if (error && error.response && error.response.data && error.response.data.status && error.response.data.status.message) {
    errorMessage = error.response.data.status.message;
  }
  let errorMsg = errorMessage
    ? errorMessage
    : 'An unexpected error has occurred. Our technical staff has been automatically notified and will be looking into this with utmost urgency.';
  if (error && error.config && error.config.config && !error.config.config.ignoreError) {
    showServiceError({
      show: true,
      data: errorMsg,
      redirect: redirect ? true : false
    });
  }
}

axios.interceptors.request.use(requestInterceptor, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use((res) => {
  return res;
}, repsonseErrorInterceptor);

export default axios;
